import { Component, OnDestroy, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subject, timer, Subscription, merge, of, fromEvent } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';
import { BreadcrumbService } from '../../../core/services/breadcrumb.service';
import { HeaderService } from '../../../core/services/header.service';
import { MenuService } from '../../../core/services/menu.service';
import { AppConfig } from './../../../config/app.config';
import { AuthenticationService } from './../../../core/services/authentication.service';

@Component({
  selector: 'sigv-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  isMenuVisible$ = this.menuService.getSideMenuObservable();
  isHeaderVisible$ = this.headerService.getHeaderObservable();
  breadcrumb$ = this.breadcrumbService.getBreadcrumbsObservable();
  networkStatus$: Subscription = Subscription.EMPTY;
  initialState: boolean = true;

  private killTrigger: Subject<void> = new Subject();
  private refreshTokenTimer$ = timer(1800000, 1800000).pipe(
    takeUntil(this.killTrigger)
  );

  constructor(
    private breadcrumbService: BreadcrumbService,
    private menuService: MenuService,
    private headerService: HeaderService,
    private appConfig: AppConfig,
    private authenticationService: AuthenticationService,
    private logger: NGXLogger
  ) {}

  ngOnInit(): void {
    if (this.appConfig.getAzureAD().enabled) {
      this.refreshTokenTimer$.subscribe({
        next: () => this.authenticationService.refreshToken(),
        error: (err) => {
          this.logger.error('Layout Component - refreshToken', err);
        },
      });
      this.checkNetworkStatus();
    }

    // 當瀏覽器不同分頁登入或登出時，重整頁面
    window.addEventListener('storage', (event) => {
      if (event.storageArea === localStorage) {
        if (this.authenticationService.isAuthenticated === false) {
          window.location.reload();
        }
      }
    }, false);
  }

  ngOnDestroy(): void {
    this.killTrigger.next();
    this.killTrigger.complete();
    this.networkStatus$.unsubscribe();
  }

  /**
   * @description 檢查網路狀態，如果networkStatus改變為true，進行refresh token
   */
  private checkNetworkStatus() {
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(isOnline => {
        this.logger.info('Network Online Status', isOnline);
        if (isOnline && !this.initialState) {
          this.authenticationService.refreshToken();
        } else {
          this.initialState = false;
        }
      });
  }
}
